module.exports = __webpack_public_path__ + "static/RI-5d732e7e0621902b02e4b39839d5fe8b.svg";